var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnAirdrop = function SvgIcnAirdrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 4.102C11.784 2.33 10.16.998 8.288.382 9.14 1.305 9.75 2.74 9.75 4.5h.659L7.676 7.535C7.617 7.521 7.563 7.5 7.5 7.5H6.375v-3H9C9 1.8 7.385 0 6 0S3 1.8 3 4.5h2.625v3H4.5c-.063 0-.117.021-.176.035L1.591 4.5h.66c0-1.76.608-3.195 1.462-4.118-1.873.619-3.497 1.95-3.71 3.72-.026.213.159.398.374.398h.204l3.204 3.56c-.016.061-.037.122-.037.19v3c0 .415.335.75.75.75h3a.75.75 0 0 0 .75-.75v-3c0-.068-.021-.127-.038-.19l3.206-3.56h.204c.218 0 .404-.183.378-.398Z",
    fill: "#A3A6AF"
  })));
};
export default SvgIcnAirdrop;